import {
  DELETE,
  DELETE_SUCCESS,
  GET_CUSTOMERS,
  GET_CUSTOMERS_SUCCESS,
  GET_DETAIL,
  GET_DETAIL_SUCCESS,
  GET_REFERENCE_DATA_SUCCESS,
  REQUEST_ERROR,
  SET_LOADING,
  SUBMIT_DATA,
  SUBMIT_DATA_SUCCESS,
  UPDATE_CUSTOMER_AVATAR_SUCCESS,
  UPDATE_CUSTOMER_SUCCESS,
  UPDATE_CUSTOMER_USERNAME,
  UPDATE_CUSTOMER_USERNAME_SUCCESS,
} from '../types/customer';
import { updateStates } from '@/utils/reducer';

const initState = {
  list: {
    data: [],
    metadata: {},
  },
  isLoading: false,
  error: '',
  item: {},
  orderStatus: [],
};

const reducer = (state = initState, action) => {
  const { type } = action;
  switch (type) {
    case GET_CUSTOMERS:
    case SUBMIT_DATA:
    case DELETE:
      return updateStates(state, {
        isLoading: true,
      });

    case GET_DETAIL:
      return updateStates(state, {
        isLoading: true,
        item: {},
      });

    case GET_CUSTOMERS_SUCCESS:
      return updateStates(state, {
        isLoading: false,
        list: action.data,
      });

    case GET_DETAIL_SUCCESS:
      return updateStates(state, {
        isLoading: false,
        item: action.data,
      });

    case UPDATE_CUSTOMER_SUCCESS:
      return updateStates(state, {
        item: { ...state.item, ...action.data },
      });

    case UPDATE_CUSTOMER_AVATAR_SUCCESS:
      return updateStates(state, {
        item: {
          ...state.item,
          files: [
            ...(state?.item?.files || []).filter((_) => _.id !== action.data.oldFile.id),
            action.data.newFile,
          ],
        },
      });

    case GET_REFERENCE_DATA_SUCCESS:
      return updateStates(state, {
        isLoading: false,
        ...action.data,
      });
    case SET_LOADING:
      return updateStates(state, {
        isLoading: action.isLoading,
      });

    case REQUEST_ERROR:
      return updateStates(state, {
        isLoading: false,
      });

    case SUBMIT_DATA_SUCCESS:
      return updateStates(state, {
        isLoading: false,
        item: action.data,
      });

    case UPDATE_CUSTOMER_USERNAME:
      return updateStates(state, { isLoading: true });

    case UPDATE_CUSTOMER_USERNAME_SUCCESS:
      return updateStates(state, { isLoading: false, item: { ...state.item, ...action.data } });

    case DELETE_SUCCESS:
      return updateStates(state, {
        isLoading: false,
        item: null,
      });
    default:
      return state;
  }
};

export default reducer;
